import { AxiosResponse } from 'axios';
import notify from 'devextreme/ui/notify';

export default function handleOKRequest(
  response: AxiosResponse<any, any>,
  message?: string
) {
  if (response.status === 200) {
    notify(
      {
        message: message ? message : 'Los cambios se hicieron correctamente',
        position: {
          my: 'center bottom',
          at: 'center bottom',
        },
      },
      'success',
      4000
    );
  }
}
